import React, {useMemo} from "react";

// Components
import {GroupButtons} from "../../../organizationManagement/components/GroupButtons";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {BeautifulTable} from "../BeautifulTable";
import {BeautifulPieChart} from "../BeautifulPieChart";

import {countByGender} from "../../model/dashboardAnalytics";
import {getGroupPathByName} from "../../model/dashboardHelpers";

type GenderCountRow = { gender: string; count: number };

export const GenderSummary = ({cases, selectedGroup, onChangeSelectedGroup}) => {
  const genderCountArray = useMemo(() => {
    const groupPath = getGroupPathByName(selectedGroup)

    const filteredCases = cases.filter(c => {
      if (groupPath === '') return true;
      return (c.category === groupPath)
    });

    return countByGender(filteredCases)
  }, [selectedGroup, cases])

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        個案性別統計
      </Typography>

      <GroupButtons
        selectedGroup={selectedGroup}
        onChangeSelectedGroup={onChangeSelectedGroup}
      />

      <BeautifulTable<GenderCountRow>
        rows={genderCountArray}
        getRowKey={(row) => row.gender}
        columns={[
          {
            key: 'question',
            header: <Typography variant="body">性別</Typography>,
            render: (row) => <Typography variant="body">{row.gender}</Typography>,
            cellClassName: 'text-gray-800',
          },
          {
            key: 'avg',
            header: <Typography variant="body">人數</Typography>,
            align: 'right',
            headerClassName: 'text-nowrap',
            cellClassName: 'font-medium text-gray-700',
            render: (row) => <Typography variant="bodyBold">{row.count}</Typography>,
          },
        ]}
      />

      <BeautifulPieChart
        dataKey="count"
        nameKey="gender"
        data={genderCountArray}
      />
    </DashboardCard>
  );
};
